import React from 'react'

import { useAuthUser } from '../user/hooks'
import { getUserPreference, getUserJsonPreference, addUserPreference, removeUserPreference } from './functions'

type PrefMapper<T> = (value: string | null) => T;

export function useUserPreference<T>(target: string, mapper: PrefMapper<T>) {
    const user = useAuthUser();
    return React.useMemo(
        () => getUserPreference(target, mapper, user),
        [user, target, mapper],
    );
}

export function useUserJsonPreference<T>(target: string, mapper: PrefMapper<T>) {
    const user = useAuthUser();
    return React.useMemo(
        () => getUserJsonPreference(target, mapper, user),
        [user, target, mapper],
    );
}

export function useUserPreferences() {
    const user = useAuthUser()

    return {
        addPreference: addUserPreference,
        removePreference: removeUserPreference,
        preferences: React.useMemo(() => {
            if (!user?.preferences) return [];
            return user.preferences;
        }, [user]),
    };
}

